import React from 'react';
import Label from '../Label';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import {
    full_ColumnGrid,
    gridSpacing20,
} from '../../../../utils/commonVariables/grid';
import {
    AttributeDefinitionState,
    AttributeValueState,
} from '../../../../types/properties/propertyTypes';
import { getGridChildSize } from '../../../../utils/property/propertyZinantisUtils';
import InputFieldFactory from './InputFieldFactory';

interface HotelAttributesSectionProps {
    title?: string;
    attributeDefinitions: AttributeDefinitionState[];
    attributeValues: AttributeValueState[];
    onChangeAttributeValue: (
        id: string,
        idAttributeDefinition: number,
        value: string | number | boolean | Date | null
    ) => void;
    onDeleteAttributeValue: (id: string, idAttributeDefinition: number) => void;
}

const HotelAttributesSection = (props: HotelAttributesSectionProps) => {
    const {
        title,
        attributeDefinitions,
        attributeValues,
        onChangeAttributeValue,
        onDeleteAttributeValue,
    } = props;

    return (
        <div className=' flex-column gap-20'>
            {title && (
                <Label
                    text={title}
                    className='border-color-bottom padding-block-8 font-size-16'
                />
            )}
            <Grid columnSpacing={gridSpacing20} rowSpacing={gridSpacing20}>
                {attributeDefinitions.map(attributeDefinition => {
                    const values = attributeValues.filter(
                        value =>
                            value.idAttributeDefinition ===
                            attributeDefinition.idAttributeDefinition
                    );
                    return (
                        <GridChild
                            key={attributeDefinition.id}
                            gridProps={
                                attributeDefinition.unique
                                    ? getGridChildSize(
                                          attributeDefinition.sizeKey
                                      )
                                    : full_ColumnGrid
                            }
                        >
                            <InputFieldFactory
                                attributeDefinition={attributeDefinition}
                                values={values}
                                onChange={onChangeAttributeValue}
                                onDelete={onDeleteAttributeValue}
                            />
                        </GridChild>
                    );
                })}
            </Grid>
        </div>
    );
};

export default HotelAttributesSection;
